import ky from 'ky'
import { endSession } from './Session'

// Protected API calls use the same ky defaults as before. In particular this
// does not alter URL construction, headers, timeouts, retry rules or payloads.
// Unauthenticated login and token renewal intentionally use plain ky.
const apiClient = ky.create({
  hooks: {
    afterResponse: [
      (request, _options, response) => {
        if (response.status !== 401) return

        // Only invalidate the current login when the rejected request used
        // its current token. Old requests must not log out a newer session.
        const requestToken = request.headers.get('Token')
        const activeToken = localStorage.getItem('token')
        if (requestToken && activeToken && requestToken === activeToken) {
          endSession()
        }
      }
    ]
  }
})

export default apiClient
